var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterpriseTv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 28C11.6225 28 11.3059 27.8722 11.0503 27.6167C10.7948 27.3611 10.667 27.0444 10.667 26.6667V25.3333H5.33366C4.60033 25.3333 3.97255 25.0722 3.45033 24.55C2.9281 24.0278 2.66699 23.4 2.66699 22.6667V6.66667C2.66699 5.93333 2.9281 5.30556 3.45033 4.78333C3.97255 4.26111 4.60033 4 5.33366 4H26.667C27.4003 4 28.0281 4.26111 28.5503 4.78333C29.0725 5.30556 29.3337 5.93333 29.3337 6.66667V22.6667C29.3337 23.4 29.0725 24.0278 28.5503 24.55C28.0281 25.0722 27.4003 25.3333 26.667 25.3333H21.3337V26.6667C21.3337 27.0444 21.2059 27.3611 20.9503 27.6167C20.6948 27.8722 20.3781 28 20.0003 28H12.0003ZM5.33366 22.6667H26.667V6.66667H5.33366V22.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterpriseTv);
export default __webpack_public_path__ + "static/media/enterprise-tv.6fcb543ffb0563b9f7d82f8b892f1170.svg";
export { ForwardRef as ReactComponent };